// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__IE9HA","item":"PaymentsMobile_item__29aEh","label":"PaymentsMobile_label__1kJGS","amount":"PaymentsMobile_amount__36757"};